import React from "react";

function NoPeople(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 111 119" {...props}>
      <g filter="url(#NoPeople__filter0_dd)">
        <path fill="#fff" d="M105 25H6a2 2 0 00-2 2v15a2 2 0 002 2h99a2 2 0 002-2V27a2 2 0 00-2-2z"></path>
      </g>
      <path
        fill="#E4E4E4"
        d="M98 35a1 1 0 102 0 1 1 0 00-2 0zm-3 0a1 1 0 102 0 1 1 0 00-2 0zm-3 0a1 1 0 102 0 1 1 0 00-2 0zm-7-2H24v4h61v-4z"></path>
      <rect width="11" height="11" x="8" y="29" fill="#005EE9" fillOpacity="0.3" rx="2"></rect>
      <g filter="url(#NoPeople__filter1_dd)">
        <path fill="#fff" d="M105 48H6a2 2 0 00-2 2v15a2 2 0 002 2h99a2 2 0 002-2V50a2 2 0 00-2-2z"></path>
      </g>
      <path
        fill="#E4E4E4"
        d="M98 58a1 1 0 102 0 1 1 0 00-2 0zm-3 0a1 1 0 102 0 1 1 0 00-2 0zm-3 0a1 1 0 102 0 1 1 0 00-2 0zm-7-2H24v4h61v-4z"></path>
      <rect width="11" height="11" x="8" y="52" fill="#F3D77D" rx="2"></rect>
      <g filter="url(#NoPeople__filter2_dd)">
        <path fill="#fff" d="M105 2H6a2 2 0 00-2 2v15a2 2 0 002 2h99a2 2 0 002-2V4a2 2 0 00-2-2z"></path>
      </g>
      <path
        fill="#E4E4E4"
        d="M98 12a1 1 0 102 0 1 1 0 00-2 0zm-3 0a1 1 0 102 0 1 1 0 00-2 0zm-3 0a1 1 0 102 0 1 1 0 00-2 0zm-7-2H24v4h61v-4z"></path>
      <rect width="11" height="11" x="8" y="6" fill="#F3D77D" rx="2"></rect>
      <g filter="url(#NoPeople__filter3_dd)">
        <path fill="#fff" d="M105 71H6a2 2 0 00-2 2v15a2 2 0 002 2h99a2 2 0 002-2V73a2 2 0 00-2-2z"></path>
      </g>
      <path
        fill="#E4E4E4"
        d="M98 81a1 1 0 102 0 1 1 0 00-2 0zm-3 0a1 1 0 102 0 1 1 0 00-2 0zm-3 0a1 1 0 102 0 1 1 0 00-2 0zm-7-2H24v4h61v-4z"></path>
      <rect width="11" height="11" x="8" y="75" fill="#005EE9" fillOpacity="0.3" rx="2"></rect>
      <g filter="url(#NoPeople__filter4_dd)">
        <path fill="#fff" d="M105 94H6a2 2 0 00-2 2v15a2 2 0 002 2h99a2 2 0 002-2V96a2 2 0 00-2-2z"></path>
      </g>
      <path
        fill="#E4E4E4"
        d="M98 104a1 1 0 102 0 1 1 0 00-2 0zm-3 0a1 1 0 102 0 1 1 0 00-2 0zm-3 0a1 1 0 102 0 1 1 0 00-2 0zm-7-2H24v4h61v-4z"></path>
      <rect width="11" height="11" x="8" y="98" fill="#005EE9" fillOpacity="0.3" rx="2"></rect>
      <path fill="url(#NoPeople__paint0_linear)" d="M1 102h109v16H1z"></path>
      <defs>
        <filter
          id="NoPeople__filter0_dd"
          width="111"
          height="27"
          x="0"
          y="23"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
        <filter
          id="NoPeople__filter1_dd"
          width="111"
          height="27"
          x="0"
          y="46"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
        <filter id="NoPeople__filter2_dd" width="111" height="27" x="0" y="0" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
        <filter
          id="NoPeople__filter3_dd"
          width="111"
          height="27"
          x="0"
          y="69"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
        <filter
          id="NoPeople__filter4_dd"
          width="111"
          height="27"
          x="0"
          y="92"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse">
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix>
          <feOffset dy="2"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend>
          <feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend>
        </filter>
        <linearGradient id="NoPeople__paint0_linear" x1="55.5" x2="55.5" y1="102" y2="118" gradientUnits="userSpaceOnUse">
          <stop stopColor="#fff" stopOpacity="0"></stop>
          <stop offset="0.672" stopColor="#fff"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default NoPeople;